import React, { FC } from 'react';
import isEmpty from 'lodash/isEmpty';
import AudioPlayer from './AudioPlayer';
import PreviewReader from './PreviewReader';
import { PRODUCT_CLASS_CAMPAIGN, ProductClass } from '../../store/constants';
import { LoanFormat, mapLoanFormat } from '../../../models/LoanFormat';

type PreviewProduct = {
    id: string; // e.g. 'PUA_407074',
    currentIssueId?: string;
    loanFormat: LoanFormat;
    sampleURL?: string;
    sampleUrl?: string;
    // TODO: sales status should be part of an Article, but this requires some API changes first
    salesStatus?: {
        key?: string; // e.g. 'PREORDER_EMBARGO';
    };
    productClass: ProductClass;
    campaignDetails?: {
        standardProductId: string;
    };
};

type Props = {
    product: PreviewProduct;
};

export const PreviewButton: FC<Props> = ({ product }) => {
    const salesStatus = product.salesStatus ?? {};
    if (!isEmpty(salesStatus) && salesStatus?.key === 'PREORDER_EMBARGO') {
        return null;
    }

    const loanFormat = mapLoanFormat(product.loanFormat);

    const previewProductId =
        product.productClass === PRODUCT_CLASS_CAMPAIGN
            ? product.campaignDetails?.standardProductId
            : loanFormat === LoanFormat.ePress
            ? product.currentIssueId
            : product.id;

    //TODO: fix me
    const previewUrl = product.sampleURL || product.sampleUrl;

    switch (loanFormat) {
        case LoanFormat.eBooks:
        case LoanFormat.ePress:
        case LoanFormat.ePressIssues:
            return previewProductId ? (
                <div id="previewButton" title="Preview" data-testid="previewButton">
                    <PreviewReader productId={previewProductId} />
                </div>
            ) : null;
        case LoanFormat.eAudiobooks:
            return previewUrl ? (
                <div id="previewButton" title="Preview" data-testid="previewButton">
                    <AudioPlayer previewUrl={previewUrl} />
                </div>
            ) : null;
        default:
            return null;
    }
};
